// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"149":"a6153050","165":"e02e1aa0","297":"6a1a706e","643":"8d675036","967":"e63667f4"}[chunkId] + ".chunk.js";
};